import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Interest } from 'src/app/shared/models/user';

@Component({
  selector: 'app-profile-interest',
  templateUrl: './profile-interest.component.html',
  styleUrls: ['./profile-interest.component.scss']
})
export class ProfileInterestComponent implements OnInit {
  @Input() interests = new BehaviorSubject<Interest[]>([]);
  dummyEl = document.createElement('DIV');

  constructor() { }

  ngOnInit(): void {
  }

  decode(text: string): string {
    let ret = '';
    this.dummyEl.innerHTML = text;
    document.body.appendChild(this.dummyEl);
    ret = this.dummyEl.textContent;
    document.body.removeChild(this.dummyEl);
    ret = ret.split('<p>&nbsp;</p>').join('');
    ret = ret.split('<strong>&nbsp;</strong>').join('');
    return ret;
  }

}
